import { ErrorMessage, type FieldValuesFromFieldErrors } from "@hookform/error-message";
import type { FieldErrors, FieldName, FieldValues } from "react-hook-form";
import { Icon } from "../icons";

/** Props Interface */
export interface FormErrorInlineProps<T extends FieldValues> {
	errors: FieldErrors<T>;
	name?: FieldName<FieldValuesFromFieldErrors<FieldErrors<T>>>;
	render?: (message: string) => React.ReactNode;
}

export function FormErrorInline<T extends FieldValues>({
	errors,
	name,
	render,
}: FormErrorInlineProps<T>) {
	/** Guard */
	if (!errors) return null;
	if (!name) return null;

	/** Render */
	return (
		<ErrorMessage
			errors={errors}
			name={name}
			render={({ message }) =>
				render ? (
					render?.(message)
				) : (
					<div className="h-stack">
						<Icon
							name="AlertTriangle"
							className="stroke-red-500"
						/>
						<p className="text-red-500">{message}</p>
					</div>
				)
			}
		/>
	);
}
